/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {memo} from 'react';
import MessageSnackbar from './SnackbarMessage';

export interface ErrorSnackbarProps {
  onDismiss: () => void;
  message: string;
  show: boolean;
}

/**
 * Displays a snackbar with an error message that only stays for 5 seconds.
 * 
 * ```typescript
 * 
 * import ErrorSnackbar from '@ion/dls/src/components/snackbars';
 * 
 * <ErrorSnackbar show={show}
 *   message={translate('common.error')}
 *   onDismiss={onDismiss} />
 * 
 * ```
 */
export const ErrorSnackbar = (props: ErrorSnackbarProps) => (
  <MessageSnackbar {...props} />
);

export default memo(ErrorSnackbar);
